import { Switch as KSwitch } from "@kobalte/core/switch";
import type { Component } from "solid-js";

interface MemoryToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const MemoryToggle: Component<MemoryToggleProps> = (props) => {
  return (
    <KSwitch
      class="flex w-full cursor-pointer items-center justify-between gap-3"
      checked={props.checked}
      onChange={props.onChange}
      disabled={props.disabled}
    >
      <KSwitch.Input class="peer" />
      <KSwitch.Label class="cursor-pointer text-sm text-primary-text select-none">{props.label}</KSwitch.Label>
      <KSwitch.Control class="inline-flex h-6 w-11 shrink-0 items-center rounded-full bg-inset pl-0.5 transition-colors duration-250 peer-focus:ring-2 peer-focus:ring-brand-hover data-checked:bg-brand data-disabled:cursor-not-allowed data-disabled:opacity-50">
        <KSwitch.Thumb class="size-5 rounded-full bg-tile transition-transform duration-250 data-checked:translate-x-full" />
      </KSwitch.Control>
    </KSwitch>
  );
};
